import React from 'react';
import {connect} from 'react-redux';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import RowLayout from '../../../../components/Layouts/RowLayout';
import Sepperator from '../../../../components/Simple/Sepperator';
import SMCLink from '../../../../components/Simple/SMCLink';
import SMCIcon from '../../../../components/Simple/SMCIcon';
import {SMCPaths} from '../../../../conf/Routes';
import {useTranslation} from 'react-i18next';
import {push} from 'connected-react-router';
import SMCLabel from '../../../../components/Simple/SMCLabel';

const pageSchema = GatewayGetSchema.pages.haMemberStatus;
const pageId = pageSchema.pageId;

function GatewayHaMemberStatus({
    gatewayObject,
    navigateTo
}) {
    const { t } = useTranslation();
    const pageData = gatewayObject[pageId];

    // The name of the cluster this gateway is a part of
    const memberOfCluster = gatewayObject[GatewayGetSchema.memberOfCluster];

    const state          = pageData[pageSchema.state];
    const lastChangeTime = pageData[pageSchema.lastChangeTime];
    const pnotes         = pageData[pageSchema.pnotes];
    const id             = pageData[pageSchema.id];

    return (
        <EditorLayout>
            <SMCTextInput
                label="State"
                value={state}
                readOnly
            />
            <SMCTextInput
                label="Last Change Time"
                value={lastChangeTime}
                readOnly
            />
            <RowLayout spacing="4px">
                <SMCTextInput
                    label="HA Gateway"
                    value={memberOfCluster}
                    readOnly
                />
                <SMCLink
                    ignoreDisabledContext
                    underline
                    onClick={() => navigateTo(`${SMCPaths.gateways}?id=${memberOfCluster}`)}
                >
                    <SMCIcon icon="rightArrow" /> {t('SMC_GEN_GO')}
                </SMCLink>

            </RowLayout>
            <Sepperator />
            <SMCLabel bold>Additional Information</SMCLabel>
            <SMCTextInput
                readOnly
                label="Pnotes"
                value={pnotes}
            />
            <SMCTextInput
                readOnly
                label="HA ID"
                value={id}
            />
            <Sepperator />
        </EditorLayout>
    )
}


const mapStateToProps = null;

const mapDispatchToProps = {
    navigateTo: push
}

export default connect(mapStateToProps, mapDispatchToProps)(GatewayHaMemberStatus);